import { createAction, props } from '@ngrx/store';
import { IDemographyData, IDemographyModel } from '@partners/api';

export class DemographyActions {
  static reset = createAction('[Demography] Reset State');

  static load = createAction('[Demography] Load');
  static loadSuccess = createAction(
    '[Demography] Load Success',
    props<{ model: IDemographyModel; data: IDemographyData }>()
  );
  static loadFailure = createAction('[Demography] Load Failure', props<{ error: any }>());
  static submit = createAction('[Demography] Submit');
  static submitSuccess = createAction(
    '[Demography] Submit Success',
    props<{ model: IDemographyModel; data: IDemographyData }>()
  );
  static submitFailure = createAction('[Demography] Submit Failure', props<{ error: any }>());
}
